import React from 'react';
import cn from 'classnames';

import YandexMap from 'src/components/YandexMap';
import RouletteMap from 'src/components/YandexMap/components/RouletteMap';
import NoCoordinatesMap from 'src/components/YandexMap/components/NoCoordinatesMap';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import HotelLayer from 'src/components/YandexMap/components/HotelLayer';

import Controls from './components/Controls';
import type { YandexHotelMapProps } from './types';
import { CHECKOUT_MAP_CONTAINER_TEST_ID } from './constants';
import styles from './yandexMapsCheckout.module.css';

const zoom = 12;

const YMapListener = loadReactComponent('YMapListener', loadModulePromise);

const YandexMapsCheckout: React.FC<Readonly<YandexHotelMapProps>> = (
  props: YandexHotelMapProps,
) => {
  const {
    isRoulette,
    location,
    onExpand,
    isMobile,
    coordinates,
    setIsMapLoading,
    showFullscreenControl,
    isExpanded,
    isNoBorderRadius,
    isNoTopBorderRadius,
  } = props;

  // Отслеживаем загрузку тайлов
  // @see https://yandex.ru/dev/jsapi30/doc/ru/dg/concepts/events#handler-interface
  const handleStateChanged = () => {
    setIsMapLoading(false);
  };

  const borderRadiusClassName = cn(styles.container, {
    [styles.withBorderRadius]: !isNoBorderRadius,
    [styles.withBottomBorderRadius]: isNoTopBorderRadius,
  });

  if (isRoulette) {
    setIsMapLoading(false);
    return (
      <RouletteMap
        className={cn(styles.emptyMapContainer, borderRadiusClassName)}
        isMobile={isMobile}
        location={location}
      />
    );
  }

  if (!coordinates) {
    setIsMapLoading(false);
    return (
      <NoCoordinatesMap
        className={cn(styles.emptyMapContainer, borderRadiusClassName)}
        isMobile={isMobile}
        location={location}
      />
    );
  }

  return (
    <div
      data-testid={CHECKOUT_MAP_CONTAINER_TEST_ID}
      className={cn(styles.container, borderRadiusClassName)}
    >
      <YandexMap isMobile={isMobile} zoom={zoom} center={coordinates}>
        <YMapListener onStateChanged={handleStateChanged} />
        <Controls
          isMobile={isMobile}
          onExpand={onExpand}
          showFullscreenControl={showFullscreenControl}
          isExpanded={isExpanded}
        />
        <HotelLayer coordinates={coordinates} />
      </YandexMap>
    </div>
  );
};

export default YandexMapsCheckout;
